/**
 * The note key, or nothing. Blank means "no note" on a create and *clears* the
 * stored one on a correction, so the rule that omission carries both meanings is
 * written once here rather than at the four payload builders.
 */
export const noteFields = (note: string): { note?: string } => {
  const trimmed = note.trim();
  return trimmed === "" ? {} : { note: trimmed };
};
